import { z } from 'zod';

const memberInputSchema = z.object({
  idLegalClient: z.number(),
  idLegalClientRelationship: z.number(),
  idRelationship: z.number(),
  idRelationshipRole: z.number(),
});

export const legalClientRelationshipInputSchema = z.object({
  Members: z.array(memberInputSchema),
  idRelationship: z.number(),
  idRelationshipType: z.number(),
});

export type ILegalClientRelationshipInput = z.infer<
  typeof legalClientRelationshipInputSchema
>;
